import React, {useState, useEffect} from 'react';
import {EmailField} from '../fields/text-like-field';
import ActionButton from '../buttons/action-button';

const FeedbackForm = ({submitAction, disabled, errorHandler}) => {

  const [model, setModel] = useState({});
  const [_disabled, setDisabled] = useState();

  useEffect(() => setDisabled(disabled), [disabled]);

  return <>
    <div className="row">
      <div className="col-12">
        <EmailField id="email"
                    label="Your email address"
                    value={model.emailAddress}
                    onChange={v => setModel({...model, emailAddress: v})}
                    disabled={_disabled}/>
      </div>
      <div className="col-12 mb-3">
        <label htmlFor="message" className="form-label">Message</label>
        <textarea id="message" name="message"
                  className="form-control"
                  style={{minHeight: '150px'}}
                  value={model.message || ''}
                  onChange={e => setModel({...model, message: e.target.value})}
                  disabled={_disabled} />
      </div>
    </div>
    <div className="row justify-content-center">
      <div className="col-4 col-md-3 d-grid">
        <ActionButton className="btn-primary"
                      action={() => submitAction(model.emailAddress, model.message)}
                      errorHandler={errorHandler}
                      disabled={!model.emailAddress || !model.message || _disabled}>
          Submit
        </ActionButton>
      </div>
    </div>
  </>;
};

export default FeedbackForm;
